module.exports = __webpack_public_path__ + "static/sorting-workspaces-66f472c5bb3064dbcb65b4589147f205.mp4";